import { render, staticRenderFns } from "./NewsStatisticsV3.vue?vue&type=template&id=a63f6124&scoped=true"
import script from "./NewsStatisticsV3.vue?vue&type=script&lang=js"
export * from "./NewsStatisticsV3.vue?vue&type=script&lang=js"
import style0 from "./NewsStatisticsV3.vue?vue&type=style&index=0&id=a63f6124&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63f6124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a63f6124')) {
      api.createRecord('a63f6124', component.options)
    } else {
      api.reload('a63f6124', component.options)
    }
    module.hot.accept("./NewsStatisticsV3.vue?vue&type=template&id=a63f6124&scoped=true", function () {
      api.rerender('a63f6124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/v3/NewsStatisticsV3.vue"
export default component.exports